export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Environmental Management Educator — London, United Kingdom',
    'My students finally understand the difference between environmental problems and management solutions. I used to waste hours searching for the right way to explain how communities can respond to environmental challenges. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Environmental Science Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain environmental impact assessment or how to teach decision-making in environmental contexts. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Sustainability and Environmental Teacher — Amsterdam, Netherlands',
    'The lesson planning saves me countless hours. The integrated environmental projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Environmental Management Educator | London, United Kingdom',
    "The material on ecosystems and environmental services completely changed how my students understand nature's value. They finally grasp how ecosystem functions support human wellbeing. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Environmental Science Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Sustainability Teacher | Berlin, Germany',
    "The 50 environmental projects transformed how my students see real-world applications. Now they investigate local environmental issues, analyze pollution sources, design management solutions, and understand why environmental knowledge matters professionally. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The environmental terminology handbook gave me back my class time. I used to spend time explaining environmental concepts and terminology. Now I show the handbook and students instantly understand environmental management concepts.',
  ],
  [
    'MS',
    'Martin S.',
    'Environmental Management Instructor | Copenhagen, Denmark',
    'The 100 case studies were eye-opening. My students finally understand why all this matters. They\'re analyzing real environmental challenges, designing management responses, making environmental decisions, and exploring sustainable solutions. This completely transformed how they see environmental management.',
  ],
];
